

























// note: for `kill`, "what happens?" is a bit vague
import { Component, Prop, Vue } from 'vue-property-decorator';
import Game from '../components/Game.vue';

@Component({
    components: {
        Game,
    },
})
export default class HTTP extends Vue {
}
